import * as React from 'react';
import MoreVertIcon from '@mui/icons-material/MoreVert';
import { Menu, MenuItem, IconButton, ListItemIcon, Typography } from '@mui/material';
import { useNavigate } from 'react-router-dom';
import toast from 'react-hot-toast';

import { getSafalEventInvitePrivateResponseDownload, getSignedURL } from '../../../../services/Service';
import Iconify from '../../../../components/Iconify';

export default function ThreeDotMenu({ onEdit, onDelete, data }) {
  const [anchorEl, setAnchorEl] = React.useState(null);
  const open = Boolean(anchorEl);
  const navigate = useNavigate();

  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };
  const handleClose = () => {
    setAnchorEl(null);
  };

  const onDisplayClick = () => {
    handleClose();
    onEdit(true);
  };

  const onEditClick = () => {
    handleClose();
    onEdit(false);
  };

  const onDeleteClick = () => {
    handleClose();
    onDelete();
  };

  const onDownloadClick = async () => {
    handleClose();
    if (!data?.form) return;
    try {
      const res = await getSafalEventInvitePrivateResponseDownload({ formId: data?.form });
      const signedURLRes = await getSignedURL({
        url: res.data.url,
      });
      const link = document.createElement('a');
      link.href = signedURLRes.data;
      link.setAttribute('download', `file`);
      document.body.appendChild(link);
      link.click();

      toast.success('download successful');
    } catch (err) {
      console.log(err);
      const msg = err?.response?.data?.message || 'download failed, please try again';
      toast.error(msg);
    }
  };

  return (
    <>
      <div>
        <IconButton
          id="basic-button"
          aria-controls={open ? 'basic-menu' : undefined}
          aria-haspopup="true"
          aria-expanded={open ? 'true' : undefined}
          onClick={handleClick}
        >
          <MoreVertIcon />
        </IconButton>
        <Menu
          id="basic-menu"
          anchorEl={anchorEl}
          open={open}
          onClose={handleClose}
          MenuListProps={{
            'aria-labelledby': 'basic-button',
          }}
        >
          {/* <MenuItem onClick={onEditClick}>
              <ListItemIcon>
                <Iconify icon="ic:twotone-mode-edit-outline" color="#1877F2" width={22} height={22} />
              </ListItemIcon>
              <Typography variant="inherit">Edit</Typography>
            </MenuItem> */}
          <MenuItem onClick={onDeleteClick}>
            <ListItemIcon>
              <Iconify icon="ic:twotone-delete" color="#DF3E30" width={22} height={22} />
            </ListItemIcon>
            <Typography variant="inherit">Delete</Typography>
          </MenuItem>
          <MenuItem onClick={onDisplayClick}>
            <ListItemIcon>
              <Iconify icon="vaadin:glasses" color="#1877F2" width={22} height={22} />
            </ListItemIcon>
            <Typography variant="inherit">Display</Typography>
          </MenuItem>
          <MenuItem onClick={onDownloadClick}>
            <ListItemIcon>
              <Iconify icon="material-symbols-light:download" color="#1877F2" width={22} height={22} />
            </ListItemIcon>
            <Typography variant="inherit">Download RSVP</Typography>
          </MenuItem>
        </Menu>
      </div>
    </>
  );
}
